import config from 'src/config/config';
import api from 'src/api/interceptor';

export function getPullEventSyncLogListApi(
  tenantOrganisationId,
  tenantId,
  typeKeyId,
  pageNumber,
  searchQuery,
  tableSortFieldOrder,
  tableSortField,
  startDate,
  endDate,
  resolved,
) {
  return api
    .get(`${config.test_url}api/crons/get-pull-event-log-list/`, {
      params: {
        tenant_organisation_id: tenantOrganisationId,
        tenant_id: tenantId,
        type_key_id: typeKeyId,
        page_number: pageNumber,
        search_query: searchQuery,
        sort_order: tableSortFieldOrder,
        sort_field: tableSortField,
        start_date: startDate,
        end_date: endDate,
        resolved,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function getPushEventSyncLogListApi(
  tenantOrganisationId,
  tenantId,
  typeKeyId,
  pageNumber,
  searchQuery,
  tableSortFieldOrder,
  tableSortField,
  startDate,
  endDate,
  resolved,
) {
  return api
    .get(`${config.test_url}api/crons/get-push-event-log-list/`, {
      params: {
        tenant_organisation_id: tenantOrganisationId,
        tenant_id: tenantId,
        type_key_id: typeKeyId,
        page_number: pageNumber,
        search_query: searchQuery,
        sort_order: tableSortFieldOrder,
        sort_field: tableSortField,
        start_date: startDate,
        end_date: endDate,
        resolved,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function triggerManualSyncEventsFromSapApi(
  tenantOrganisationId,
  tableNumbers,
) {
  const urlParams = new URLSearchParams();
  urlParams.append('tenant_organisation_id', tenantOrganisationId);
  if (tableNumbers instanceof Array) {
    tableNumbers.forEach((tableNumber) =>
      urlParams.append('table_number', tableNumber),
    );
  }

  return api
    .post(
      `${config.test_url}api/crons/trigger-manual-sync-events-from-sap/`,
      urlParams,
    )
    .then((res) => Promise.resolve(res));
}
